import React, { useMemo } from 'react';

import { ICON } from '../../icons/iconIds';
import SelkirkIcon from '../icons/SelkirkIcon';
function buildTree(folders) {
  const root = { children: new Map() };
  folders.forEach((f) => {
    let node = root;
    f.path.split('/').forEach((segment, i, parts) => {
      if (!node.children.has(segment)) {
        node.children.set(segment, {
          name: segment,
          path: parts.slice(0, i + 1).join('/'),
          count: 0,
          children: new Map(),
        });
      }
      node = node.children.get(segment);
    });
    node.count = f.asset_count || 0;
  });

  const withTotals = (node) => {
    const kids = [...node.children.values()].sort((a, b) => a.name.localeCompare(b.name)).map(withTotals);
    return { ...node, children: kids, total: node.count + kids.reduce((s, k) => s + k.total, 0) };
  };
  return withTotals(root).children;
}

const FolderNode = ({ node, depth, selectedPath, onSelect }) => (
  <li>
    <button
      type="button"
      className={`dd-folder-item ${selectedPath === node.path ? 'active' : ''}`}
      style={{ paddingLeft: `${0.75 + depth * 0.9}rem` }}
      onClick={() => onSelect(node.path)}
    >
      <span className="dd-folder-name">{depth === 0 ? <SelkirkIcon name={ICON.ddFolder} size={14} variant="branch" decorative /> : <SelkirkIcon name={ICON.ddTreeBranch} size={14} variant="branch" decorative />} {node.name}</span>
      <span className="dd-folder-count">{node.total}</span>
    </button>
    {node.children.length > 0 && (
      <ul>
        {node.children.map((child) => (
          <FolderNode key={child.path} node={child} depth={depth + 1} selectedPath={selectedPath} onSelect={onSelect} />
        ))}
      </ul>
    )}
  </li>
);

const FolderTree = ({ folders, selectedPath, onSelect }) => {
  const tree = useMemo(() => buildTree(folders || []), [folders]);
  const total = tree.reduce((s, n) => s + n.total, 0);

  return (
    <nav className="dd-folder-tree" aria-label="Brand Library folders">
      <ul>
        <li>
          <button
            type="button"
            className={`dd-folder-item ${!selectedPath ? 'active' : ''}`}
            onClick={() => onSelect('')}
          >
            <span className="dd-folder-name"><SelkirkIcon name={ICON.ddTabBrandLibrary} size={14} variant="branch" decorative /> All photos</span>
            <span className="dd-folder-count">{total}</span>
          </button>
        </li>
        {tree.map((node) => (
          <FolderNode key={node.path} node={node} depth={0} selectedPath={selectedPath} onSelect={onSelect} />
        ))}
      </ul>
    </nav>
  );
};

export default FolderTree;
